import InnerPageHeading from "./InnerPageHeading";

function Testimonial(){
    return(
        <>
            <InnerPageHeading title="Testimonials"/>
            <section className="gfe-sec">
                <div className="container">
                    <div className="cooming-soon">
                        Page Comming Soon...
                    </div>
                </div>
           </section>
        </>
    );
}

export default Testimonial;